import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'app/service/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  appName : string;

  constructor(public commonService: CommonService, private router : Router) { 
  }

  navigateTo(elem) {
    if(elem.hyperLink && !elem.description) {
      window.open(elem.hyperLink, "_blank");
    } else {
      elem.description = elem.description.replace(/\$/gi,'\n');
      this.router.navigate(['/cms',this.commonService.pages?.id,elem.label]);
      this.commonService.link = elem;
    }
  }
 


}
